import type { RouteRecordRaw } from "vue-router";
const onError = (err: any) => {
  console.error("Failed to load async component: ", err);
  throw new Error(err);
};

const Advertiser: RouteRecordRaw = {
  name: "广告主管理",
  path: "/advertiser",
  component: () => import("@/components/Layout/index.vue").catch(onError),
  meta: {
    key: "/advertiser"
  },
  children: [
    {
      name: "广告主列表",
      path: "adv-list",
      component: () =>
        import("@/views/Advertiser/Adv/AdvList/index.vue").catch(onError),
      meta: {
        key: "/advertiser/adv-list",
        keepAlive: true
      }
    },
    {
      name: "SHEIN - ROI涨跌趋势看板",
      path: "shein-roi-panel",
      meta: {
        key: "/advertiser/shein-roi-panel"
      },
      component: () =>
        import("@/views/Advertiser/KaUnique/Shein/RoiPanel/index.vue").catch(
          onError
        )
    },
    {
      name: "上游回传日志",
      path: "adv-postback-log",
      component: () =>
        import("@/views/Advertiser/AdvPostbackLog/index.vue").catch(onError),
      meta: {
        key: "/advertiser/adv-postback-log"
      }
    },
    {
      name: "广告主日报",
      path: "daily-report",
      component: () =>
        import("@/views/Advertiser/DailyReport/index.vue").catch(onError),
      meta: {
        key: "/advertiser/daily-report"
      }
    },
    {
      name: "事件映射管理",
      path: "event-mapping-manage",
      component: () =>
        import("@/views/Advertiser/EventMappingManage/index.vue").catch(
          onError
        ),
      meta: {
        key: "/advertiser/event-mapping-manage",
        keepAlive: true
      }
    },
    {
      name: "计费事件映射",
      path: "detail",
      component: () =>
        import("@/views/Advertiser/AdvDetail/index.vue").catch(onError),
      meta: {
        key: "/advertiser/detail"
      }
    },
    {
      name: "RTA平台配置",
      path: "open-user-rta",
      component: () =>
        import("@/views/Advertiser/OpenUserRTA/index.vue").catch(onError),
      meta: {
        key: "/advertiser/open-user-rta",
        keepAlive: true
      }
    }
  ]
};

export default Advertiser;
